<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form size="small">
        <el-row :gutter="10">
          <el-col :span="6">
            <!--业务日期-->
            <el-form-item :label="$t('orderCenterCont.DateBusiness')">
              <el-date-picker
                v-model="dateArr"
                :clearable="false"
                :end-placeholder="$t('operationCenter.endDate')"
                :picker-options="pickerOptions"
                :range-separator="$t('operationCenter.to')"
                :start-placeholder="$t('operationCenter.startDate')"
                popper-class="dateTimeClass"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
                @blur="refreshDate"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--客户-->
            <el-form-item
              :label="$t('orderCenterCont.customer')"
              prop="region"
              style="width: 100%"
            >
              <el-select
                v-model="queryForm.customerId"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%"
                remote
                reserve-keyword
                :remote-method="getUserOption"
                @visible-change="getUserOption()"
              >
                <el-option
                  v-for="(item, index) in customerList"
                  :key="index"
                  :label="item.customerAlias + '（' + item.username + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--是否核收-->
            <el-form-item
              :label="$t('receivablePayable.WhetherToCheckOrNot')"
              prop="region"
              style="width: 100%"
            >
              <el-select
                v-model="queryForm.isAccept"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
                <el-option :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--是否生成对账单-->
            <el-form-item
              :label="$t('receivablePayable.WhetherToGenerateAStatement')"
              prop="region"
              style="width: 100%"
            >
              <el-select
                v-model="queryForm.isGenBill"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
                <el-option :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="getData">{{ $t('GlobalSetObj.search') }}</el-button>
          <el-button type="primary" @click="showResetData = true">{{ $t('basicData.刷新数据') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="box-card">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-card class="box-card">
            <div style="font-size: 16px">
              <!--揽收-->
              <span style="font-weight: bold">{{ $t('collectionCenter.lanshou') }}-</span>
              <!--总票数-->
              {{ $t('compensationManagement.TotalNumberOfVotes') }}：
              <span>{{ collectingVotes }}</span>,
              <!--总金额：-->
              {{ $t('compensationManagement.TotalAmount') }}：
              <span>{{ collectingAmount }}</span>
            </div>
            <div id="collecting" style="width: 100%;height: calc(100vh - 450px)" />
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div style="font-size: 16px">
              <!--快递-->
              <span style="font-weight: bold">{{ $t('collectionCenter.expressDelivery') }}-</span>
              <!--总票数：-->
              {{ $t('compensationManagement.TotalNumberOfVotes') }}：
              <span>{{ expressVotes }}</span>,
              <!--总金额：-->
              {{ $t('compensationManagement.TotalAmount') }}：
              <span>{{ expressAmount }}</span>
            </div>
            <div id="express" style="width: 100%;height: calc(100vh - 450px)" />
          </el-card>
        </el-col>
      </el-row>
    </el-card>
    <!--刷新数据-->
    <el-dialog
      :visible.sync="showResetData"
      :title="$t('basicData.刷新数据')"
      width="400px"
      append-to-body
      modal-append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeResetWindow"
    >
      <div>
        <el-form
          :key="showResetData"
          ref="resetDataForm"
          :model="resetDataForm"
          label-position="top"
        >
          <el-form-item
            :label="$t('GlobalSetObj.Date')"
            prop="resetDataDate"
            :rules="[{ required: true, message: $t('collectionCenter.PleaseSelectTime'), trigger: ['change', 'blur'] }]"
          >
            <el-date-picker
              v-model="resetDataForm.resetDataDate"
              type="date"
              :placeholder="$t('collectionCenter.PleaseSelectTime')"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmRefresh">{{ $t('GlobalSetObj.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import * as echarts from 'echarts';
import { apiCustomerPage } from '@/api/customer';
import { getReceivableDashboard, refreshReceivableDashboard } from '@/api/finance/partition';
export default {
  name: 'AccountsReceivableDashboard',
  data() {
    return {
      queryForm: {
        customerId: null,
        startDate: '',
        endDate: '',
        isAccept: null,
        isGenBill: null
      },
      customerList: [],
      choiceDate0: '',
      dateArr: [this.getAWeek().startDate, this.getAWeek().endDate],
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() - 30);
          const maxTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() + 30);
          const min = minTime;
          // const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000;
          const newDate = ((d) => (d.setHours(0, 0, 0, 0), d.setDate(d.getDate() + 1), d.getTime()))(new Date());
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        }
      },
      collectingChart: null,
      expressChart: null,
      showResetData: false,
      resetDataForm: {
        resetDataDate: ''
      },
      collectingData: [], // 揽收数据
      expressData: [], // 快递数据
      collectingVotes: 0, // 揽收总票数
      collectingAmount: 0, // 揽收总金额
      expressVotes: 0, // 快递总票数
      expressAmount: 0 // 快递总金额
    };
  },
  mounted() {
    this.getUserOption();
    // 添加 resize 事件监听器
    window.addEventListener('resize', this.resizeHandler);
    this.getData();
  },
  methods: {
    // 确定刷新数据
    confirmRefresh() {
      this.$refs.resetDataForm.validate((valid) => {
        if (valid) {
          // const startDate = {
          //   startDate: this.resetDataForm.resetDataDate
          // };
          refreshReceivableDashboard(this.resetDataForm.resetDataDate).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.getData();
              this.closeResetWindow();
            }
          });
        }
      });
    },
    // 关闭刷新数据弹窗
    closeResetWindow() {
      this.showResetData = false;
      this.resetDataForm.resetDataDate = '';
    },
    // 日期选择器失去焦点
    refreshDate() {
      this.choiceDate0 = '';
    },
    // 获取当月日期的起止日期
    getAWeek() {
      return {
        endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
        startDate: dayjs().startOf('month').format('YYYY-MM-DD')
      };
    },
    // 客户名称列表
    getUserOption(username = '') {
      const queryCustomerParam = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: username
        }
      };
      apiCustomerPage(queryCustomerParam, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    // 渲染折线图
    getData() {
      const param = {
        customerId: this.queryForm.customerId,
        isAccept: this.queryForm.isAccept,
        isGenBill: this.queryForm.isGenBill,
        startDate: '',
        endDate: ''
      };
      if (this.dateArr.length > 0) {
        param.startDate = this.dateArr[0];
        param.endDate = this.dateArr[1];
      }
      getReceivableDashboard(param).then(res => {
        if (res.code === 200) {
          if (this.collectingChart) {
            this.collectingChart.clear();
          }
          if (this.expressChart) {
            this.expressChart.clear();
          }
          this.collectingData = []; // 揽收数据
          this.expressData = []; // 快递数据
          this.collectingVotes = 0; // 揽收总票数
          this.collectingAmount = 0; // 揽收总金额
          this.expressVotes = 0; // 快递总票数
          this.expressAmount = 0; // 快递总金额
          const colorList = [
            { color: '#1bbc9c' },
            { color: '#4dd0e1' },
            { color: '#e1bee7' },
            { color: '#ffb74d' },
            { color: '#e57373' },
            { color: '#64b5f6' },
            { color: '#FF0000' },
            { color: '#af64dd' }
          ];
          if (res.data && res.data.length > 0) {
            res.data.map((item, index) => {
              const obj = {
                name: item.customerName,
                value: item.qty,
                amount: item.fee,
                exTotalQty: item.exTotalQty,
                exTotalFee: item.exTotalFee,
                clTotalQty: item.clTotalQty,
                clTotalFee: item.clTotalFee,
                itemStyle: colorList[index]
              };
              if (item.businessType === 0) {
                this.expressData.push(obj);
              } else {
                this.collectingData.push(obj);
              }
            });
            this.collectingVotes = this.collectingData.length > 0 ? this.collectingData[0].clTotalQty : 0; // 揽收总票数
            this.collectingAmount = this.collectingData.length > 0 ? this.collectingData[0].clTotalFee : 0; // 揽收总金额
            this.expressVotes = this.expressData.length > 0 ? this.expressData[0].exTotalQty : 0; // 快递总票数
            this.expressAmount = this.expressData.length > 0 ? this.expressData[0].exTotalFee : 0; // 快递总金额
            const collecting = document.getElementById('collecting');
            const express = document.getElementById('express');
            this.collectingChart = echarts.init(collecting);
            this.expressChart = echarts.init(express);
            const option1 = {
              tooltip: {
                trigger: 'item',
                formatter: (params) => {
                  return `${params.data.name}:<br>${params.data.value} ` + this.$t('basicData.ticket') + `，${params.data.amount} BRL，${((params.data.value / this.collectingVotes) * 100).toFixed(2)}%`;
                }
              },
              legend: {
                orient: 'vertical',
                type: 'scroll',
                right: 10,
                top: 'middle',
                formatter: (name) => {
                  const item = this.collectingData.find(item => item.name === name);
                  if (item) {
                    const text = `${item.name}: ${item.value} ` + this.$t('basicData.ticket') + `，${item.amount} BRL，${((item.value / this.collectingVotes) * 100).toFixed(2)}%`;
                    return text.match(/.{1,30}/g).join('\n');
                  }
                  return name.match(/.{1,30}/g).join('\n');
                },
                textStyle: {
                  fontSize: 14, // 设置字体大小
                  color: '#333' // 设置字体颜色
                },
                selectedMode: false
              },
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  center: ['25%', '50%'],
                  radius: ['50%'],
                  data: this.collectingData,
                  label: {
                    show: false,
                    position: 'center'
                  },
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ]
            };
            const option2 = {
              tooltip: {
                trigger: 'item',
                formatter: (params) => {
                  return `${params.data.name}:<br>${params.data.value} ` + this.$t('basicData.ticket') + `，${params.data.amount} BRL，${((params.data.value / this.expressVotes) * 100).toFixed(2)}%`;
                }
              },
              legend: {
                orient: 'vertical',
                type: 'scroll',
                right: 10,
                top: 'middle',
                formatter: (name) => {
                  const item = this.expressData.find(item => item.name === name);
                  if (item) {
                    const text = `${item.name}: ${item.value} ` + this.$t('basicData.ticket') + `，${item.amount} BRL，${((item.value / this.expressVotes) * 100).toFixed(2)}%`;
                    return text.match(/.{1,30}/g).join('\n');
                  }
                  return name.match(/.{1,30}/g).join('\n');
                },
                textStyle: {
                  fontSize: 14, // 设置字体大小
                  color: '#333' // 设置字体颜色
                },
                selectedMode: false
              },
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  center: ['25%', '50%'],
                  radius: ['50%'],
                  data: this.expressData,
                  label: {
                    show: false,
                    position: 'center'
                  },
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ]
            };
            if (this.collectingData.length > 0) {
              option1 && this.collectingChart.setOption(option1);
            }
            if (this.expressData.length > 0) {
              option2 && this.expressChart.setOption(option2);
            }
          }
        }
      });
    },
    resizeHandler() {
      this.collectingChart.resize();
      this.expressChart.resize();
    }
  }
};
</script>

<style scoped>

</style>
